import { render, staticRenderFns } from "./UIProgressCircular.vue?vue&type=template&id=3090f898&"
import script from "./UIProgressCircular.vue?vue&type=script&lang=js&"
export * from "./UIProgressCircular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports